<app-export-status
  [exportObject]="feed"
  *ngIf="isDownlaoding$ | async"
></app-export-status>
<div class="feed">
  <div class="panes">
    <div
      id="posts"
      class="pane pane-posts {{ paneClass }}"
      *ngIf="feed?.views?.includes('list')"
    >
      @if (feed?.is_paused) {
        <div class="feed-paused-banner" role="status">
          <fa-icon
            class="feed-paused-banner__icon"
            [icon]="['fas', 'pause-circle']"
          ></fa-icon>
          <div class="feed-paused-banner__text">
            <div class="feed-paused-banner__title">Updates paused</div>
            <div class="feed-paused-banner__message">
              @if (feed.timestamp_paused) {
                No new posts have been added since
                {{
                  feed.timestamp_paused * 1000
                    | date: NomDateTimeFormats.ANALYTICS_LONG
                }}.
              } @else {
                No new posts are being added to this feed.
              }
            </div>
          </div>
          <button
            type="button"
            class="feed-paused-banner__action"
            (click)="openFeedSettings()"
          >
            Open settings
          </button>
        </div>
      }
      <app-post-list
        #postList
        [posts]="posts$ | async"
        [loading]="postsLoading$ | async"
        [feed]="feed"
        [viewMode]="viewMode"
        [viewConfig]="feedViewConfig"
        [timeShown]="timeShown"
        [user]="user"
        [currentLanguage]="currentLanguage"
        [feedSearchQuery]="feedSearchQuery"
        [selectedPostId]="selectedPostId"
        [currentPage]="currentPage$ | async"
        [itemsPerPage]="itemsPerPage$ | async"
        [totalItemsCount]="totalItemsCount$ | async"
        [loadingAlgorithmPostIds]="loadingAlgorithmPostIds$ | async"
        [appliedAlgorithmPostIds]="appliedAlgorithmPostIds$ | async"
        [isStoryMode]="isStoryFeed"
        (togglePostDetails)="onTogglePostDetails($event.event, $event.index)"
        (requestToggleThread)="onRequestToggleThread($event)"
        (pageChanged)="onPageChanged($event)"
        (itemsPerPageChanged)="onItemsPerPageChanged($event)"
      >
        <app-feed-results-toolbar postListToolbar></app-feed-results-toolbar>
      </app-post-list>
    </div>

    <!-- Second Pane -->
    <div
      class="pane pane-details {{ paneClass }}"
      *ngIf="feed?.views?.includes('details')"
      [class.pane-details--has-post]="selectedPostId$ | async"
    >
      <button
        type="button"
        class="pane-details__close"
        aria-label="Close details"
        (click)="closePostDetails()"
      >
        <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
      </button>
      <app-story-card-details
        *ngIf="isStoryFeed"
        [postId]="selectedPostId$ | async"
        [feedId]="feed.id"
        [viewConfig]="feedViewConfig"
      >
      </app-story-card-details>
      <app-post-card-details
        *ngIf="!isStoryFeed"
        [postId]="selectedPostId$ | async"
        [feedId]="feed.id"
      >
      </app-post-card-details>
    </div>

    <div
      id="widgets"
      class="pane pane-widgets {{ paneClass }}"
      *ngIf="feed?.views?.includes('analytics')"
    >
      <app-widget-toolbar
        (searchChange)="handleSearchStringWidgetChange($event)"
        (refresh)="widgetRefresh()"
        (configure)="widgetConfigure()"
        (selectAllChange)="selectAllWidgets($event)"
      ></app-widget-toolbar>

      <div
        class="card-container widgets"
        *ngIf="{
          selectedPlaceholderId: selectSelectedPlaceholderId$ | async,
          editMode: currentObjectEditMode$ | async,
          objectViewProperties: objectViewProperties$ | async,
          countSelectedWidgets: countSelectedWidgets$ | async,
        } as data"
      >
        <gridstack
          *ngIf="!widgetEditMode"
          [options]="gridstackOptions"
          (changeCB)="onGridChange($event)"
          (dragover)="onDragOver($event)"
          (drop)="onDrop($event)"
        >
          <div class="app-loading-wrapper" *ngIf="widgetsLoading$ | async">
            <app-loading-card
              type="widget"
              [count]="feed.count_widgets ? feed.count_widgets : 1"
            ></app-loading-card>
          </div>

          <!-- options must be a reference-stable object (built in the component):
               a new reference makes gridstack-item call grid.update() on every
               change-detection cycle -->
          <gridstack-item
            *ngFor="
              let item of widgetsWithGridOptions$ | async;
              trackBy: widgetTrackByFn
            "
            [options]="item.gridOptions"
          >
            <app-widget-card
              [widget]="item.widget"
              [currentObject]="feed"
              [user]="user"
              [isPlaceholderSelected]="
                item.widget.id === data.selectedPlaceholderId
              "
              [objectActionService]="objectActionService"
              [editMode]="data.editMode"
              [viewProperties]="data.objectViewProperties"
              [resizingWidgetId$]="resizingWidgetId$"
              [isDragging$]="isDragging$"
              [searchString]="widgetSearchString"
            ></app-widget-card>
          </gridstack-item>
        </gridstack>

        <div
          class="widget-cardlist-container not-draggable"
          *ngIf="widgetEditMode"
          [appSortableList]="widgetsSortableList"
          [sortableDisabled]="widgetSearchString?.length > 0"
          [dragThreshold]="5"
          [dragDelay]="150"
          [scrollSpeed]="50"
          [scrollSensitivity]="80"
          (sorted)="onWidgetListSorted($event)"
          (dragover)="onDragOver($event)"
          (drop)="onDrop($event)"
        >
          <!-- Do not convert to new @for loop syntax - track is required and breaks the dragging positions!!! -->
          <div *ngFor="let widget of widgetsSortableList" class="widget-item">
            @if (widget.widget_type_id !== WidgetType.WIDGET_TYPE_PLACEHOLDER) {
              <app-widget-card-list
                [widget]="widget"
                [objectActionService]="objectActionService"
                [searchString]="widgetSearchString"
                (selectSectionBreak)="selectSectionBreakWidget($event)"
              ></app-widget-card-list>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Sidebar -->
  <app-sidebar
    [buttons]="filteredSidebarButtons$ | async"
    [object]="feed$ | async"
    (componentSelected)="loadComponent($event)"
    #sidebar
  ></app-sidebar>
</div>
